// 미디어 센터 허브 — /blog
// '전체' 탭이 활성인 상태. 화면 구성은 /blog/:section 과 동일하다(MediaCenterView).
import { MediaCenterView } from '../features/MediaCenter/MediaCenterView';

export function BlogPage() {
  return <MediaCenterView />;
}
